import React from 'react';
import { useTranslation } from '../i18n';

interface Props {
  isVerified: boolean;
  hasExternalId: boolean;
  verifiedAt: string | null;
  reverifying: boolean;
  loading?: boolean;
  onStartReverify: (silent: boolean) => void;
}

export const MojeIdVerificationSection: React.FC<Props> = ({
  isVerified,
  hasExternalId,
  verifiedAt,
  reverifying,
  loading,
  onStartReverify,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return <p className="text-muted">{t('mojeid.loading')}</p>;
  }

  const isExpired = hasExternalId && verifiedAt != null && !isVerified;

  return (
    <div className="card" style={{ marginBottom: '1rem' }}>
      <h3 style={{ marginTop: 0 }}>{t('mojeid.section_title')}</h3>

      {isVerified && (
        <>
          <div className="alert alert-success">{t('account.verification_verified')}</div>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => onStartReverify(hasExternalId)}
            disabled={reverifying}
          >
            {reverifying && <span className="btn-spinner" aria-hidden="true" />}
            {t('mojeid.reverify_button')}
          </button>
        </>
      )}

      {isExpired && (
        <>
          <div className="alert alert-warning">{t('mojeid.verification_expired')}</div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => onStartReverify(hasExternalId)}
            disabled={reverifying}
          >
            {reverifying && <span className="btn-spinner" aria-hidden="true" />}
            {t('mojeid.reverify_button')}
          </button>
        </>
      )}

      {!isVerified && !isExpired && (
        <>
          <div className="alert alert-warning">{t('account.verification_pending')}</div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => onStartReverify(hasExternalId)}
            disabled={reverifying}
          >
            {reverifying && <span className="btn-spinner" aria-hidden="true" />}
            {t('mojeid.verify_button')}
          </button>
        </>
      )}
    </div>
  );
};
